import React, { useState } from 'react';

import ReactMarkdown from 'react-markdown';
import {
  Container,
  Position,
  Role,
  Image,
  RoleContainer,
  Wrapper,
} from './OpenPosition.styles';

export default function OpenPosition({
  position: { role, description, medias },
  careerTitle,
}) {
  return (
    <Wrapper>
      <RoleContainer>
        <Role afterContent={careerTitle} key={role}>
          {role}
        </Role>
      </RoleContainer>

      <Container>
        <ReactMarkdown children={description} />
        {medias && medias.map(({ url }) => <Image src={url} />)}
      </Container>
    </Wrapper>
  );
}
